/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'



const basePath = '/membership/membership-plans'

const membershipPlanEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchMembershipPlans: builder.query<any, string>({
    query: () => ({
      url: `${basePath}`,
      method: 'get',
    }),
    providesTags: ['membershipPlans'],
  }),

  createMembershipPlan: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['membershipPlans'],
  }),

  deleteMembershipPlan: builder.mutation<any, any>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['membershipPlans'],
  }),

  updateMembershipPlan: builder.mutation<any, any>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['membershipPlans'],
  }),

})

export default membershipPlanEndpoints



